var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeedback(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_238_1",
    "data-name": "Component 238 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7569",
    "data-name": "Rectangle 7569",
    width: 32,
    height: 32,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "chat_24dp_E8EAED_FILL0_wght300_GRAD0_opsz24_1_",
    "data-name": "chat_24dp_E8EAED_FILL0_wght300_GRAD0_opsz24 (1)",
    d: "M104.248-847.254h8.5v-1.7h-8.5Zm0-3.4h13.029v-1.7H104.248Zm0-3.4h13.029v-1.7H104.248ZM100-839v-18.955a1.977,1.977,0,0,1,.595-1.453,1.977,1.977,0,0,1,1.453-.595h17.43a1.977,1.977,0,0,1,1.453.595,1.977,1.977,0,0,1,.595,1.453v12.9a1.977,1.977,0,0,1-.595,1.453,1.977,1.977,0,0,1-1.453.595H104.009Zm3.286-5.708h16.192a.333.333,0,0,0,.24-.109.333.333,0,0,0,.109-.24v-12.9a.333.333,0,0,0-.109-.24.333.333,0,0,0-.24-.109h-17.43a.333.333,0,0,0-.24.109.333.333,0,0,0-.109.24v14.815Zm-1.586,0v0Z",
    transform: "translate(-95 865)",
    fill: "#810155"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/Feedback.9b82d1d80847818727942f9d067291e5.svg";
export { ForwardRef as ReactComponent };